export const customizedColumns = {
  customize_columns: "Customize Columns",
  customize_columns_title: "Customize Columns",
  customize_columns_description:
    "Choose which columns are shown by default in the table.",
  columns_updated_successfully: "Columns updated successfully",
  customize_columns_disabled_filtered_view:
    "Columns cannot be customized while filtered view is applied",
  reset_to_default: "Reset to default",
  invoice_id: "Invoice ID",
  po_id: "PO ID",
  delivery_note_id: "Delivery Note ID",
  vendor_company_name: "Vendor Company Name",
  customer_company_name: "Customer Company Name",
  document_date: "Document Date",
};
